import React from 'react';

interface AddressWidgetProps {
  namespace: string;
  formMethods: any;
  hideCountryField?: boolean;
  disabled?: boolean;
}

const AddressWidget: React.FC<AddressWidgetProps> = ({
  namespace,
  formMethods,
  hideCountryField,
  disabled,
}) => {
  const { register } = formMethods;

  return (
    <div className="address-widget">
      <div className="address-row">
        <div>
          <label htmlFor={`${namespace}street`}>Street</label>
          <input
            id={`${namespace}street`}
            {...register(`${namespace}street`)}
            disabled={disabled}
          />
        </div>
        <div>
          <label htmlFor={`${namespace}housenr`}>House Number</label>
          <input
            id={`${namespace}housenr`}
            {...register(`${namespace}housenr`)}
            disabled={disabled}
          />
        </div>
      </div>

      <div>
        <label htmlFor={`${namespace}zipcode`}>Zip Code</label>
        <input
          id={`${namespace}zipcode`}
          {...register(`${namespace}zipcode`)}
          disabled={disabled}
        />
      </div>

      <div className="address-row">
        <div>
          <label htmlFor={`${namespace}district`}>District</label>
          <input
            id={`${namespace}district`}
            {...register(`${namespace}district`)}
            disabled={disabled}
          />
        </div>
        <div>
          <label htmlFor={`${namespace}neighbourhood`}>Neighbourhood</label>
          <input
            id={`${namespace}neighbourhood`}
            {...register(`${namespace}neighbourhood`)}
            disabled={disabled}
          />
        </div>
      </div>

      <div>
        <label htmlFor={`${namespace}city`}>City</label>
        <input
          id={`${namespace}city`}
          {...register(`${namespace}city`)}
          disabled={disabled}
        />
      </div>

      {!hideCountryField && (
        <div>
          <label htmlFor={`${namespace}country`}>Country</label>
          <input
            id={`${namespace}country`}
            {...register(`${namespace}country`)}
            disabled={disabled}
          />
        </div>
      )}
    </div>
  );
};

export default AddressWidget;
